export default __webpack_public_path__ + "static/media/malayali.1ad18e9c.svg";